"use strict"
import f from "./frames.json"
import s from "./systems.json"
import w from "./weapons.json"

const data = {
  frames: f,
  systems: s,
  weapons: w,
}

export default data;